module.exports = __webpack_public_path__ + "img/¥6.00.b5640b81.png";